var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organization)?_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('personal-organization',{staticStyle:{"width":"40em"},model:{value:(_vm.organization),callback:function ($$v) {_vm.organization=$$v},expression:"organization"}}),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6023a77d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/personal/organization.vue
// module id = null
// module chunks = 